import { Helmet } from 'react-helmet'
import payment_policy2 from '../assets/payment_policy2.png'
import payment_policy_mobile2 from '../assets/payment_policy_mobile2.png'
import Footer from '../components/footer/Footer.components'
import Header from '../components/header/Header.components'
import '../styles/PaymentPolicy.css'

function PaymentPolicy() {
  return (
    <div>
      <Helmet>
        <title>資金決済法に基づく表記</title>
      </Helmet>
      <Header />
      <div className="payment-policy">
        <img className="content" src={payment_policy2} alt="" />
        <img className="content-mobile" src={payment_policy_mobile2} alt="" />
      </div>
      <Footer />
    </div>
  )
}

export default PaymentPolicy
